import type { MatchRule } from './matchRule';

// Mental addition: the enemy shows "3+4" and is destroyed by firing 7. The
// enemy's `value` IS the answer, so matching is identity and the projectile
// pipeline needs no changes. Sums are capped at 9 — the weapon is a digit.
export const additionRule: MatchRule = {
  id: 'addition',
  label: 'Add It Up',
  instructions: 'Add the two numbers in your head and fire the sum.',
  answerFor: (value) => value,
  displayFor: (value) => String(value),
  matches: (input, value) => input === value,
  generate: (rng) => {
    const a = rng.int(0, 10); // 0-9
    const b = rng.int(0, 10 - a); // keeps a+b ≤ 9
    return { value: a + b, display: `${a}+${b}` };
  },
};
